<template>
  <div class="row">
    <div class="col-12">
      <h2 class="text-white">{{ t.all_vendors }}</h2>
    </div>
    <div class="col-12 text-white d-flex align-items-center justify-content-end">
      <div class="mr-5">
        <input id="acceptancePointsCheckbox" v-model="showAcceptancePoints" type="checkbox" />
        <label class="text-white" for="acceptancePointsCheckbox">{{ t.acceptance_points }}</label>
      </div>
      <div>
        <input id="issuePointsCheckbox" v-model="showIssuePoints" type="checkbox" />
        <label class="text-white" for="issuePointsCheckbox">{{ t.issue_points }}</label>
      </div>
    </div>
    <div class="col-24">
      <div v-if="filteredVendors.length > 0" class="row">
        <div v-for="(vendor, i) in filteredVendors" :key="i" class="col-sm-8 mb-2">
          <VendorTile
            :badges="vendor.badges"
            :categories="vendor.categories"
            :address="vendor.address"
            :description="vendor.description"
            :image="vendor.image"
            :name="vendor.name"
            :product-link="
              vendor.product_link && { url: vendor.product_link, text: t.product_link }
            "
            :link="vendor.url && { url: vendor.url, text: t.profile_link }"
          >
          </VendorTile>
        </div>
      </div>
      <div v-else class="text-white mt-2 mb-2 font-weight-bold">
        {{ t.no_vendors }}
      </div>
    </div>
  </div>
</template>
<script>
import VendorTile from "./VendorTile.vue";
export default {
  name: "VoucherVendorList",
  components: {
    VendorTile,
  },
  props: {
    vendors: {
      type: Array,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAcceptancePoints: true,
      showIssuePoints: true,
    };
  },
  computed: {
    listableVendorTypes() {
      return [
        this.showAcceptancePoints ? "acceptance_point" : null,
        this.showIssuePoints ? "issue_point" : null,
      ];
    },
    filteredVendors() {
      return this.vendors.filter(vendor => {
        return this.listableVendorTypes.some(type =>
          vendor.badges.map(badge => badge.key).includes(type)
        );
      });
    },
  },
};
</script>
